import {
  REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD,
  RECEIVE_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD,
  REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD_ERROR
} from 'actions'
import createApiMiddlewareReducer from '../utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD,
  receive: RECEIVE_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD,
  failure: REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD_ERROR
})

export default function (state = {}, { type, payload = {} }) {
  switch (type) {
    case REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD:
    case RECEIVE_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD:
    case REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD_ERROR:
      const { workspaceSlug } = payload
      return {
        ...state,
        [workspaceSlug]: reducer(state[workspaceSlug], { type, payload })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/mtus/by-source-for-current-period.js